import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getAsync } from '../helper/axiosHelper';
import Loader from '../Loader/Loader';
import { DataNotFound } from '../DataNotFound';

const SMSModal = ({ smsModal, setSmsModal, projectId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [networkOne, setNetworkOne] = useState([]);
    const [datanotfound, setDatanotfound] = useState(false);
  const { t } = useTranslation();

  const [selectedNetWork, setSelectedNetWork] = useState({
    networkName: '',
    amount: '',
  });

  useEffect(() => {
    getSmsData();
  }, [projectId ]);

  const getSmsData = async () => {
    setIsLoading(true)
    setDatanotfound(false);
    const response = await getAsync(`APIClient/GetSMSByID?ProjectId=${projectId}`);
    if (response) {
      setNetworkOne(response?.data);
      setIsLoading(false)
    }
    if (response?.statusCode == 204) {
      setIsLoading(false);
      setDatanotfound(true);
    }
  };



  const handleHitMessage = (item) => {
    setSelectedNetWork((prevState) => {
      const newState = { ...prevState };
      newState.amount = item.amount;
      newState.networkName = item.network;
      return newState;
    });
  };
  return (
    <>
      {smsModal ? (
        <>
          <div className="modal-overlay justify-star items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-[500px] mx-auto max-w-3xl">
              <div className="relative font-inter antialiased">
                <main className="relative min-h-screen flex flex-col justify-center overflow-hidden">
                  <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-24">
                    <div className="flex justify-center h-96 ">
                      <div className=" sm:w-[400px] sm:h-[400px] text-center bg-white text-black  px-4 sm:px-8 py-4 rounded-xl shadow">
                        {!isLoading ? (
                          <div>
                            <div>
                              <p onClick={() => setSmsModal(false)} className="text-right cursor-pointer text-gray-500 text-2xl">
                                x
                              </p>
                              <header className="">
                                <h1 className="text-2xl font-bold mb-1">{t('Donate by SMS')}</h1>
                              </header>
                            </div>
                            <div className="space-y-8  h-64 flex items-center">
                              {/* NetWork One */}
                              <div>
                                {/* <div className="flex flex-row  items-center gap-2 mb-4 ">
                                  <div>
                                    <img src="https://shjc.sharjah.ae/etisalat.png" className="w-12" alt="" />
                                  </div>
                                </div> */}
                                <div className="flex gap-3  justify-center sxx:justify-start flex-wrap">
                                  {networkOne?.map((item, index) => (
                                    <div key={index} className="mb-2 cursor-pointer sm:w-full w-auto  ">
                                      <div
                                        name="amount"
                                        value={item?.smsValue}
                                        onClick={() => handleHitMessage(item)}
                                        className="text-white  px-4 w-full bg-gradient-to-r from-customgreen via-customgreen to-customgreen bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-customgreen dark:focus:ring-customgreen font-medium rounded-md text-sm py-2 text-center"
                                      >
                                        <a
                                        className='hover:text-white'
                                         href="sms:6215?&amp;body=100" >

                                        {item?.smsValue}
                                        </a>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                                   {datanotfound && <DataNotFound />}

                              {/* NetWork Two */}
                              {/* <div>
                                <div className="flex flex-row  items-center gap-2 mb-4 ">
                                  <div>
                                    <img src="https://shjc.sharjah.ae/du.png" className="w-12" alt="" />
                                  </div>
                                </div>
                                <div className="flex gap-3  justify-center sxx:justify-start flex-wrap">
                                  {NetworkTwo.map((item, index) => (
                                    <div key={index} className="mb-2 cursor-pointer sm:w-full w-auto ">
                                      <div
                                        name="amount"
                                        value={item.amount}
                                        onClick={() => handleHitMessage(item)}
                                        className="text-white px-4 w-full bg-gradient-to-r from-customgreen via-customgreen to-customgreen bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-customgreen dark:focus:ring-customgreen font-medium rounded-md text-sm py-2 text-center"
                                      >
                                        {item.amount}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div> */}
                            </div>
                          </div>
                        ) : (
                          <div className="flex justify-center items-center h-full">
                          <Loader />
                          </div>
                        )}

                      </div>
                    </div>
                  </div>
                </main>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default SMSModal;
